import { render, staticRenderFns } from "./ClientCompanyDetail.vue?vue&type=template&id=3458012b&scoped=true"
import script from "./ClientCompanyDetail.vue?vue&type=script&lang=js"
export * from "./ClientCompanyDetail.vue?vue&type=script&lang=js"
import style0 from "../../css/newProjectDetail.css?vue&type=style&index=0&id=3458012b&prod&scoped=true&lang=css&external"
import style1 from "./ClientCompanyDetail.vue?vue&type=style&index=1&id=3458012b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3458012b",
  null
  
)

export default component.exports